import Cookies from 'js-cookie';

export const search = (search: string): string[] => {
  const cookies = Cookies.get();

  const foundCookies = Object.entries(cookies)?.reduce<string[]>(
    (acc, [cookieName]) => {
      if (cookieName?.includes(search)) {
        return [...acc, cookieName];
      }
      return acc;
    },
    []
  );

  return foundCookies;
};

export const deleteOne = (cookieName: string) => {
  Cookies.remove(cookieName, { path: '', domain: '.pagopa.it' });
};

export const deleteMany = (cookieNames: string[]) => {
  cookieNames?.forEach(deleteOne);
};
